import queryString from 'query-string'
import humps from 'humps'
import apiClient from './api-client'

function byPracticeId({
  practiceId,
  fromDate,
  toDate,
  page,
  filters,
  conditions,
}) {
  const options = { withHeaders: true }
  const query = humps.decamelizeKeys({
    ...conditions,
    from_date: fromDate,
    to_date: toDate,
  })
  if (page) query.page = page

  return apiClient.get(
    queryString.stringifyUrl({
      url: `/practices/${practiceId}/office-checks`,
      query,
    }),
    options,
  )
}

function get(practiceId, id, query) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `/practices/${practiceId}/office-checks/${id}`,
      query,
    }),
  )
}

function create(practiceId, data) {
  return apiClient.post(`/practices/${practiceId}/office-checks`, {
    office_check: {
      patientId: data.patientId,
      checkDate: data.dateOfCheck,
    },
  })
}

function update(id, practiceId, data) {
  return apiClient.put(`/practices/${practiceId}/office-checks/${id}`, {
    office_check: {
      ...data,
    },
  })
}

async function getReportForm(id, practiceId) {
  return apiClient.get(
    `/practices/${practiceId}/office-checks/${id}/report/form`,
  )
}

async function saveReportForm(id, practiceId, reportValues) {
  return apiClient.put(
    `/practices/${practiceId}/office-checks/${id}/report/form`,
    reportValues,
  )
}

async function processDeviceReport(id, practiceId, formData) {
  return apiClient.patch(
    `/practices/${practiceId}/office-checks/${id}/report/process`,
    formData,
  )
}

function signReport(id, practiceId) {
  return apiClient.put(`/practices/${practiceId}/office-checks/${id}/signature`)
}

function destroy(id, practiceId) {
  return apiClient.destroy(`/practices/${practiceId}/office-checks/${id}`)
}

function getBatch(practiceId, fromDate, toDate) {
  return apiClient.get(
    `/practices/${practiceId}/office-checks/reports/batch?from_date=${fromDate}&to_date=${toDate}`,
  )
}

function createBatch(practiceId, fromDate, toDate) {
  return apiClient.post(
    `/practices/${practiceId}/office-checks/reports/batch?from_date=${fromDate}&to_date=${toDate}`,
  )
}

function downloadFile(practiceId, fromDate, toDate) {
  return apiClient.get(
    `/practices/${practiceId}/office-checks/reports/file?from_date=${fromDate}&to_date=${toDate}`,
  )
}

export default {
  byPracticeId,
  get,
  create,
  update,
  getReportForm,
  processDeviceReport,
  saveReportForm,
  signReport,
  destroy,
  getBatch,
  createBatch,
  downloadFile,
}
